export default __webpack_public_path__ + "images/assets/a3c3f5fb6ae475724fa412335c10ec2a.svg";